import { render } from "./IntermediateScreenWaves.vue?vue&type=template&id=51e8279f&scoped=true&ts=true"
import script from "./IntermediateScreenWaves.vue?vue&type=script&lang=ts"
export * from "./IntermediateScreenWaves.vue?vue&type=script&lang=ts"

import _style_0 from "./IntermediateScreenWaves.vue?vue&type=style&index=0&id=51e8279f&inline&scoped=true&lang=scss"

import exportComponent from "/Users/philippniestroj/Desktop/AgenturPhilipp/ProductFinder/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]],['__scopeId',"data-v-51e8279f"]])

export default __exports__